import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import axios from '../../../../../data/http/axios'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Column from '~/Common-Objects/Grids/Column/Column'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Row from '~/Common-Objects/Grids/Row/Row'
import * as siteActions from '../../../../../data/actions/siteActions'
import DeleteOrg from '../remove'
import Subscribers from './subscribers'
import Tags from './tags'
import Fields from './fields'
import PermissionChecker from '../../../../../Classes/permissions'

export default function Organisation() {
    const params = useParams()
    const [organisation, setOrganisation] = useState(null)
    const [apps, setApps] = useState([])
    const dispatch = useDispatch()
    const history = useHistory()
    const permissionStore = useSelector(state => state.permission)

    const getOrg = async () => {
        const res = await axios.get('/organisation/' + params.id)
        setOrganisation(res.data.Organisation)
    }

    const getApps = async () => {
        const res = await axios.get('/organisation/' + params.id + '/application')
        setApps(res.data)
    }

    const deleteOrg = () => {
        const drawer = <DeleteOrg organisation={organisation} onFinish={r => {
            dispatch(siteActions.alterSiteDrawer(false))
            if (r) history.push('/cp/subscribers/organisations')
        }} />
        dispatch(siteActions.alterSiteDrawer(true, true, 'right', drawer, true, 400))
    }

    useEffect(() => {
        getOrg()
        getApps()
    }, [params.id])


    const writeAccess = PermissionChecker('subscribers', permissionStore.permissions, 'write')

    if (!organisation) return <LoadingIcons iconType="2" />

    return (
        <div>
            <Row>
                <Column xs={12} sm={6} className="mar-b25">
                    <h4>{organisation.name}</h4>
                </Column>
                <Column xs={12} sm={6} className="mar-b25 center-xs end-sm">
                    {apps.map(a => <Button iconRight={<Icons icon="newWindow" />} key={a.Application.id} text={"View in " + a.Application.appName} className="mar-r10" onClick={() => window.open(a.link, '_blank')} />)}
                    {writeAccess && <Button text="Delete" className="button-red" onClick={deleteOrg} iconRight={<Icons icon="cross" />} />}
                </Column>
            </Row>

            <Row>
                <Column xs={12} sm={12} md={4}>
                    <Tags organisation={organisation} />
                    <Fields organisation={organisation} refresh={getOrg} />
                </Column>
                <Column xs={12} sm={12} md={8}>
                    <Subscribers />
                </Column>
            </Row>

        </div>
    )
}